var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 629.249,
    viewBox: "0 0 960 629.249",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-437 -192.301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.659,385.862l170.828,20.819-19.674-59.02-148.257-4.714c-7.074-8.356-18.392-14.176-31.486-15.06-22.912-1.548-42.523,12.569-43.8,31.529S206.522,395,229.434,396.551C242.528,397.435,254.526,393.19,262.659,385.862Z",
    transform: "translate(698.239 362.822)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.184,202.109,209.813,358.967l-56.5,38.328,12.3,44.266L320.48,459.793,262.839,212.645l-29.57-16.963a8.082,8.082,0,0,0-12.082,6.427Z",
    transform: "translate(862.694 310.255)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.6,72.6a83.081,83.081,0,1,0-70.772,113.737l54.36,92.572,50.653-93.778a469,469,0,0,1-39.718-38.06C314.99,124.162,314.972,98.469,304.6,72.6Z",
    transform: "translate(856.78 241.486)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.849,206.978,96.6,131.652s36.888-17.214,49.184,36.888c0,0,83.036-2.142,106.319,75.326s60.164,306.169,60.164,306.169H31L.215,247.36A41.783,41.783,0,0,1,20.85,206.977h0Z",
    transform: "translate(1084.737 271.515)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.248,230.541c.679-10.247,5.431-21.821,14.122-34.4,6.984-10.1,16.507-20.868,28.305-31.987A364.267,364.267,0,0,1,202,131.476l-.781-1.156c-.05.034-5.106,3.459-12.587,9.188-6.9,5.284-17.345,13.675-27.9,23.62-11.872,11.188-21.463,22.027-28.5,32.215-8.84,12.792-13.675,24.6-14.368,35.106Z",
    transform: "translate(1018.084 293.359)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.386,311.7s.693-.474,12.3-31.97l113.279,76.2-34.588,29.536Z",
    transform: "translate(513.772 343.858)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.386,308.014s.619-.419,10.98-28.288L428.52,347.155,397.636,373.3Z",
    transform: "translate(518.98 349.104)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.95,390.561l170.83,20.821-19.674-59.02-148.257-4.714c-7.074-8.356-18.392-14.176-31.486-15.06-22.912-1.548-42.523,12.569-43.8,31.529s16.253,35.585,39.166,37.132c13.094.884,25.093-3.361,33.226-10.689Z",
    transform: "translate(716.694 364.676)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.925,377.715V232.781S173.746,109.1,265.748,172.259c0,0-26.366,298.045-72.263,310.839s-111.12-6.5-111.12-6.5L60.1,405.408Z",
    transform: "translate(1043.723 300.901)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.211,478.553c13.507,0,25.521-1.46,35.714-4.34a18.985,18.985,0,0,0,8.443-5.7,55.666,55.666,0,0,0,7.785-11.4c4.731-8.792,9.447-21.074,14.015-36.5,7.68-25.942,15.1-61.175,22.063-104.724,3.416-21.378,8.564-56.482,13.687-102.307,3.064-27.405,4.689-45.892,4.7-46.076l-1.327-.118c-.016.179-1.636,18.659-4.7,46.05-2.826,25.279-7.493,63.537-13.678,102.241-6.952,43.491-14.361,78.666-22.026,104.549-4.543,15.341-9.222,27.535-13.909,36.245-5.091,9.46-10.277,14.992-15.413,16.444-10.112,2.858-22.056,4.3-35.5,4.29a241.35,241.35,0,0,1-34.925-2.784,295.841,295.841,0,0,1-37.165-7.905l-.378,1.292a297.328,297.328,0,0,0,37.35,7.947,242.668,242.668,0,0,0,35.12,2.8Z",
    transform: "translate(1066.692 310.524)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.363,388.354l79.69-28.4V211.675h-1.39V358.968L152.9,387.04Z",
    transform: "translate(950.695 316.997)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.231,57.444C88.769,56.2,95.959,65.972,99.3,74.979s5.879,19.518,14.169,24.388c11.328,6.657,25.82-1.351,38.774.846,14.627,2.488,24.14,17.983,24.882,32.8s-5.151,29.069-10.938,42.733l-2.02-16.981a33.668,33.668,0,0,1-14.711,29.429l2.606-24.915a26.442,26.442,0,0,1-30.421,21.876l.409-14.844A245.268,245.268,0,0,1,71.162,172.8c-16.945-1.529-34.01-6.893-46.854-18.051C5.115,138.037-1.916,110.564.437,85.208S13.255,36.066,24.153,13.054C26.894,7.267,30.69.737,37.046,0A12.989,12.989,0,0,1,49.768,9.6a34.75,34.75,0,0,1-.153,17.062c-1.61,8.528-3.633,17.268-2.132,25.832s7.671,17.016,16.3,18.07S81.236,61.745,79.231,57.444Z",
    transform: "matrix(-0.848, 0.53, -0.53, -0.848, 1197.495, 351.888)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437 352.994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.32,316.069H205.7a6.688,6.688,0,0,1-6.681-6.681V188.181A6.688,6.688,0,0,1,205.7,181.5H611.32A6.688,6.688,0,0,1,618,188.181V309.388a6.688,6.688,0,0,1-6.681,6.681ZM205.7,183.409a4.777,4.777,0,0,0-4.772,4.772V309.388a4.777,4.777,0,0,0,4.772,4.772H611.32a4.777,4.777,0,0,0,4.772-4.772V188.181a4.777,4.777,0,0,0-4.772-4.772Z",
    transform: "translate(-199.024 -181.5)",
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.687,374.284a3.745,3.745,0,0,1-2.208-.731l-5.322-3.867a2.579,2.579,0,0,0-3.042,0l-5.322,3.867a3.757,3.757,0,0,1-5.782-4.2l2.033-6.256a2.582,2.582,0,0,0-.94-2.894l-5.322-3.867a3.757,3.757,0,0,1,2.208-6.8h6.579a2.581,2.581,0,0,0,2.461-1.788l2.033-6.256a3.757,3.757,0,0,1,7.147,0l2.033,6.256a2.581,2.581,0,0,0,2.461,1.788h6.579a3.757,3.757,0,0,1,2.208,6.8l-5.322,3.867a2.582,2.582,0,0,0-.94,2.894l2.033,6.256a3.7,3.7,0,0,1-1.365,4.2,3.746,3.746,0,0,1-2.208.731Z",
    transform: "translate(-206.513 -188.679)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.2,374.284a3.745,3.745,0,0,1-2.208-.731l-5.322-3.867a2.579,2.579,0,0,0-3.042,0l-5.322,3.867a3.757,3.757,0,0,1-5.782-4.2l2.033-6.256a2.582,2.582,0,0,0-.94-2.894l-5.322-3.867a3.757,3.757,0,0,1,2.208-6.8h6.578a2.581,2.581,0,0,0,2.461-1.788l2.033-6.256a3.757,3.757,0,0,1,7.146,0l2.033,6.256a2.582,2.582,0,0,0,2.461,1.788h6.578a3.757,3.757,0,0,1,2.208,6.8l-5.322,3.867a2.582,2.582,0,0,0-.94,2.894l2.033,6.256a3.7,3.7,0,0,1-1.365,4.2,3.745,3.745,0,0,1-2.208.731Z",
    transform: "translate(-209.091 -188.679)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.7,374.284a3.746,3.746,0,0,1-2.208-.731l-5.322-3.867a2.585,2.585,0,0,0-3.042,0l-5.322,3.867a3.757,3.757,0,0,1-5.781-4.2l2.033-6.256a2.582,2.582,0,0,0-.94-2.894l-5.322-3.867a3.757,3.757,0,0,1,2.208-6.8h6.578a2.581,2.581,0,0,0,2.461-1.788l2.033-6.256a3.757,3.757,0,0,1,7.146,0l2.033,6.256a2.581,2.581,0,0,0,2.461,1.788H509.3a3.757,3.757,0,0,1,2.209,6.8l-5.322,3.867a2.582,2.582,0,0,0-.94,2.894l2.033,6.256a3.7,3.7,0,0,1-1.365,4.2A3.746,3.746,0,0,1,503.7,374.284Z",
    transform: "translate(-211.668 -188.679)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.727,211.5a6.2,6.2,0,1,0,0,12.407H567.721a6.2,6.2,0,1,0,0-12.407Z",
    transform: "translate(-201.236 -182.868)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.727,245.5a6.2,6.2,0,1,0,0,12.407H567.721a6.2,6.2,0,1,0,0-12.407Z",
    transform: "translate(-201.236 -184.419)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.727,279.5a6.2,6.2,0,1,0,0,12.407H567.721a6.2,6.2,0,1,0,0-12.407Z",
    transform: "translate(-201.236 -185.97)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.727,211.5a6.2,6.2,0,1,0,0,12.407H567.721a6.2,6.2,0,1,0,0-12.407Z",
    transform: "translate(-201.236 -182.868)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.727,245.5a6.2,6.2,0,1,0,0,12.407H567.721a6.2,6.2,0,1,0,0-12.407Z",
    transform: "translate(-201.236 -184.419)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.727,279.5a6.2,6.2,0,1,0,0,12.407H567.721a6.2,6.2,0,1,0,0-12.407Z",
    transform: "translate(-201.236 -185.97)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.7,374.284a3.746,3.746,0,0,1-2.208-.731l-5.322-3.867a2.585,2.585,0,0,0-3.042,0l-5.322,3.867a3.757,3.757,0,0,1-5.781-4.2l2.033-6.256a2.582,2.582,0,0,0-.94-2.894l-5.322-3.867a3.757,3.757,0,0,1,2.208-6.8h6.578a2.581,2.581,0,0,0,2.461-1.788l2.033-6.256a3.757,3.757,0,0,1,7.146,0l2.033,6.256a2.581,2.581,0,0,0,2.461,1.788H509.3a3.757,3.757,0,0,1,2.209,6.8l-5.322,3.867a2.582,2.582,0,0,0-.94,2.894l2.033,6.256a3.7,3.7,0,0,1-1.365,4.2A3.746,3.746,0,0,1,503.7,374.284Z",
    transform: "translate(-157.737 -188.679)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.7,374.284a3.746,3.746,0,0,1-2.208-.731l-5.322-3.867a2.585,2.585,0,0,0-3.042,0l-5.322,3.867a3.757,3.757,0,0,1-5.781-4.2l2.033-6.256a2.582,2.582,0,0,0-.94-2.894l-5.322-3.867a3.757,3.757,0,0,1,2.208-6.8h6.578a2.581,2.581,0,0,0,2.461-1.788l2.033-6.256a3.757,3.757,0,0,1,7.146,0l2.033,6.256a2.581,2.581,0,0,0,2.461,1.788H509.3a3.757,3.757,0,0,1,2.209,6.8l-5.322,3.867a2.582,2.582,0,0,0-.94,2.894l2.033,6.256a3.7,3.7,0,0,1-1.365,4.2A3.746,3.746,0,0,1,503.7,374.284Z",
    transform: "translate(-103.806 -188.679)",
    fill: "#234ba2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewEmptyState);
export default __webpack_public_path__ + "static/media/review-empty-state.9567cb705a57320af8ff97191f6a4dc1.svg";
export { ForwardRef as ReactComponent };